import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "../../assets/jss/material-dashboard-pro-react/components/customInputStyle";
import {
	FormControl,
	FormHelperText,
	Input,
	InputLabel,
	makeStyles,
} from "../../utils/barrels/material-ui-core";

const useStyles = makeStyles(styles);

export default function CustomInput(props) {
	const classes = useStyles();
	const {
		formControlProps,
		labelText,
		id,
		labelProps,
		inputProps,
		error,
		white,
		inputRootCustomClasses,
		success,
		helperText,
		helperState,
		style,
	} = props;

	const labelClasses = classNames({
		[` ${classes.labelRootError}`]: error,
		[` ${classes.labelRootSuccess}`]: success && !error,
	});
	const underlineClasses = classNames({
		[classes.underlineError]: error,
		[classes.underlineSuccess]: success && !error,
		[classes.underline]: true,
		[classes.whiteUnderline]: white,
	});
	const marginTop = classNames({
		[inputRootCustomClasses]: inputRootCustomClasses !== undefined,
	});
	const inputClasses = classNames({
		[classes.input]: true,
		[classes.whiteInput]: white,
	});
	let formControlClasses;
	if (formControlProps !== undefined) {
		formControlClasses = classNames(
			formControlProps.className,
			classes.formControl
		);
	} else {
		formControlClasses = classes.formControl;
	}
	const helpTextClasses = classNames({
		[classes.labelRootError]: error,
		[classes.labelRootSuccess]: success && !error,
	});
	return (
		<FormControl {...formControlProps} className={formControlClasses}>
			{labelText !== undefined ? (
				<InputLabel
					className={`${classes.labelRoot} ${labelClasses}`}
					htmlFor={id}
					style={style}
					{...labelProps}
				>
					{labelText}
				</InputLabel>
			) : null}
			<Input
				classes={{
					input: inputClasses,
					root: marginTop,
					disabled: classes.disabled,
					underline: underlineClasses,
				}}
				id={id}
				{...inputProps}
				autoComplete="chrome-off"
			/>
			{helperText !== undefined ? (
				<FormHelperText
					id={`${id}-text`}
					className={helpTextClasses}
					{...helperState}
				>
					{helperText}
				</FormHelperText>
			) : null}
		</FormControl>
	);
}

CustomInput.propTypes = {
	labelText: PropTypes.node,
	labelProps: PropTypes.object,
	id: PropTypes.string,
	inputProps: PropTypes.object,
	formControlProps: PropTypes.object,
	inputRootCustomClasses: PropTypes.string,
	error: PropTypes.bool,
	success: PropTypes.bool,
	white: PropTypes.bool,
	helperText: PropTypes.node,
};
